import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const RobotIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 7V4m6 3V4M6 9h12a2 2 0 012 2v5a4 4 0 01-4 4h-8a4 4 0 01-4-4v-5a2 2 0 012-2zm3 4h.01M15 13h.01"
    />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default RobotIcon;
